import { debug } from '../../../../../config';
import { utcDateTimeConversion } from '../../../../../utils/date';
import {defaultImg} from '../../../utils/defaultImg';
import {getImg, getTicketLinkHtml, getEventSharingOptionsHtml} from './eventLogic';
import { isValid } from '../../../utils/validate';
import { getMonth } from '../../../utils/date';
import ensuringCorrectYear from '../../../../../carousel-react/src/utils/ensuringCorrectYear';


function getEventHtml(popUp, event) {
  debug && console.log('Called event');
  // get and sanitize event variables
  const eventImg = getImg(popUp, event.eventImage);
  const eventName = event.event;

   let eventDateTime='';
   if (isValid(event.datetimeUTC) && 
         (String(event.datetimeLocal).split(' ')[4]==='00:00:00' ||
          String(event.datetimeLocal).split(' ')[1]==='00:00:00') ) {
      const eventMonth = isValid(getMonth(event.month)) ? 
      getMonth(event.month)+' ': '';
      const eventDay = isValid(event.day) ? event.day+', ': '';      
      const eventYear = ensuringCorrectYear(event.datetimeUTC);
      eventDateTime=eventMonth+eventDay+eventYear;
   }

   else if (isValid(event.datetimeUTC)) {
      eventDateTime = utcDateTimeConversion(event.datetimeUTC);
   }

   else {
      const eventMonth = isValid(getMonth(event.month)) ? 
         getMonth(event.month)+' ': '';
      const eventDay = isValid(event.day) ? event.day+', ': '';
      eventDateTime=eventMonth+eventDay;
   }

  const venueName = event.venueName;
  const ticketLink = getTicketLinkHtml(event.ticketLink);
  const venueAddress = event.address;
  return `<section class="hearby-section-summarydetails">
                   <div class="hearby-details-row">
                      <div class="hearby-col hearby-col-40">
                         <img src="${eventImg}"  onerror="this.onerror=null;this.src='${defaultImg()}';"
                          srcset="" class="hearby-details-eventimage">
                      </div>
                      <div class="hearby-col hearby-col-60">
                         <div class="hearby-event-modal-description">
                           <h1>${eventName}</h1>
                            <div class="hearby-venue-details">
                               <span class="hearby-details-datetime">${eventDateTime}</span>
                               <span class='hearby-details-sep'>at</span>
                               <span class="hearby-details-venuename">${venueName}</span>
                               <span class="marker-box__address">${venueAddress}</span>
                            </div>
                            <div className="hearby-share-popover-area">
                              ${getEventSharingOptionsHtml(popUp)}     
                            </div>
                            <div class="hearby-event-modal-buttons"> 
                               ${ticketLink}
                            </div>
                         </div>
                      </div>
                   </div>
                </section>`;
}
export {getEventHtml};
